import React from 'react';

import { useTranslation } from "react-i18next";

import footer from '../img/footer.png';

function Footer() {

  const { t } = useTranslation();

  return (
    <div className='z-10 relative pt-[80px] xl:pt-[140px] bg-[#F4F1E8]'>
      <div className='max-w-[1220px] mx-[20px] xl:mx-auto relative'>
        <p className='PtRoot text-[12px] xl:text-[14px] text-[#FFFFFF80] absolute hidden xl:block inset-[35px]'>{t('footer.2')} Support@auditandrecovery-consulting.com</p>
        <p className='absolute hidden xl:block xl:top-[250px] text-white left-[35px] text-[20px] sm:text-[24px] md:text-[32px] xl:text-[48px] xl:max-w-[500px] leading-[1.2]'>{t('footer.1')}</p>
        <img src={footer} alt="" />
        <div className='bg-[#382F12] h-[414px] mt-[-132px] flex flex-col items-center'> 
            <p className='pt-[180px] mx-[20px] text-[#FFFFFF80] text-[12px] xl:text-[14px] PtRoot text-center xl:max-w-[489px]'>{t('footer.3')}</p>
            <p className='pt-[12px] mx-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] PtRoot font-[700]'>{t('footer.7')}</p>
            <p className='mx-[20px] PtRoot text-[#FC2E00] text-[12px] xl:text-[14px] font-[700]'>Support@auditandrecovery-consulting.com</p>
            <p className='mx-[20px] pt-[4px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] PtRoot font-[700]'>{t('footer.4')}</p>
            <a href=""><p className='pt-[12px] mx-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] PtRoot font-[700]'>{t('footer.5')}</p></a>
            <p className='pt-[40px] mx-[20px] text-[#FFFFFF80] text-[12px] xl:text-[14px] PtRoot text-center'>{t('footer.6')}</p>
        </div>
      </div>
     </div>
  );
}

export default Footer;